<template>
  <div>
    <v-tooltip top v-if="tooltip">
      <template v-slot:activator="{ on, attrs }">
        <div class="ellipsis-text" v-on="on" :style="style">
          <!-- @slot Message will be displayed in tooltip-->
          <slot></slot>
        </div>
      </template>
      <slot></slot>
    </v-tooltip>
    <div v-else>
      <!-- @slot Original message will be displayed here-->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EllipsisText",
  props: {
    /**
     * Filter returns the function
     */
    filter: { type: Object, default: () => {} },
    /**
     * Full message will be display in tooltip if it sets to true
     */
    tooltip: { type: Boolean, default: true },
    /**
     * Hides the sentence according to its width and apply dots at the end
     */
    width: { default: null },
  },
  computed: {
    visible() {
      return Object.keys(this.filter).indexOf("name") >= 0;
    },
    style() {
      return {
        "max-width": !!this.width ? `${this.width}px` : "100%",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.ellipsis-text {
  max-width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>